import { ChartType } from 'chart.js';

export class ChartKind {
    static readonly Line: ChartType = 'line';
    static readonly Bar: ChartType = 'bar';
    static readonly Pie: ChartType = 'pie';
    static readonly Radar: ChartType = 'radar';
    static readonly PolarArea: ChartType = 'polarArea';
    static readonly Doughnut: ChartType = 'doughnut';
}
